import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/modules/shared.module';
import { StandbyListInfoComponent } from './standby-list-info/standby-list-info.component';
import { StandbyListCardComponent } from './standby-list-card/standby-list-card.component';
import { SeatMapComponent } from './seat-map/seat-map.component';

@NgModule({
  declarations: [
    StandbyListInfoComponent,
    StandbyListCardComponent,
    SeatMapComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [
    StandbyListCardComponent,
    SeatMapComponent,
    StandbyListInfoComponent,
  ],
})
export class StandbyListModule {}
